/* eslint-disable */
import {Filtro} from "../models/filtro/filtro";


export const BlogSCH = (perPage)=> {
    var filtro = new Filtro()
    filtro.perPage = perPage
    filtro.fields = ['*']
    filtro.addOrder('dt_criacao', 'desc')
    filtro.addOrder('titulo', 'asc')
  return filtro
}


export const  getBlogSCH = (campo, valor, condicao)=>{
  var filtro = new Filtro()
  filtro.perPage = 1
  filtro.filters.addFilter(campo,valor,condicao)
  return filtro
}

